import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { XCircle } from 'lucide-react';
import { Button } from '@/components/ui/button';

export default function PaymentCancelPage() {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <div
      className="min-h-dvh flex items-center justify-center px-4"
      style={{ background: 'var(--theme-background)' }}
      data-testid="payment-cancel-page"
    >
      <div
        className="w-full max-w-sm rounded-3xl p-8 text-center"
        style={{
          background: 'var(--glass-bg)',
          backdropFilter: 'blur(20px)',
          border: '1px solid var(--glass-border)',
        }}
      >
        <div
          className="mx-auto mb-4 flex h-16 w-16 items-center justify-center rounded-full"
          style={{ background: 'rgba(239,68,68,0.12)' }}
        >
          <XCircle className="h-9 w-9 text-red-400" />
        </div>
        <h2 className="text-xl font-semibold mb-2" style={{ color: 'var(--theme-text)' }}>
          {t('payment.cancel_title')}
        </h2>
        <p className="text-sm mb-6" style={{ color: 'var(--theme-textSecondary)' }}>
          {t('payment.cancel_desc')}
        </p>
        <Button
          onClick={() => navigate('/app')}
          className="w-full rounded-xl py-5 font-medium"
          style={{ background: 'var(--theme-accent)', color: '#fff' }}
          data-testid="payment-cancel-return-btn"
        >
          {t('payment.cancel_cta')}
        </Button>
      </div>
    </div>
  );
}
